import React, { useState } from "react";

import {
  medium,
  mediumHover,
  twitter,
  twitterHover,
  discord,
  discordHover,
  gitbook,
  gitbookHover,
} from "../assets";
import logo from "../assets/menuButtonsAndStates/nr-logo-transparent.png";
import { Modal } from "./Modal";

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const openModal = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const handleMouseEnterTwitter = (event) => {
    event.target.src = twitterHover;
  };
  const handleMouseLeaveTwitter = (event) => {
    event.target.src = twitter;
  };
  const handleMouseEnterDiscord = (event) => {
    event.target.src = discordHover;
  };
  const handleMouseLeaveDiscord = (event) => {
    event.target.src = discord;
  };
  const handleMouseEnterMedium = (event) => {
    event.target.src = mediumHover;
  };
  const handleMouseLeaveMedium = (event) => {
    event.target.src = medium;
  };
  const handleMouseEnterGitbook = (event) => {
    event.target.src = gitbookHover;
  };
  const handleMouseLeaveGitbook = (event) => {
    event.target.src = gitbook;
  };

  const termsText = `
OWNERSHIP & LICENSE
Congratulations on owning a NodeRunners Genesis Pilot NFT. The following is a lot of words that indicates you can do whatever you want with your Genesis Pilot as long as it´s in your wallet. When you transfer it, then all of that moves to the next owner. Also, we would like to retain the ability to use the NFTs in marketing and promotion for the collection as a whole. 
1. Ownership. Whenever you mint or purchasea Genesis Pilot, as long as that NFT remains in a wallet that youown, you own the NFT. Ownership of the NFT is mediated entirely by a smart contract on the Ethereum Network, so at no point may we or anyone else seize, freeze, or otherwise modify the ownership of any Genesis Pilot NFT. 
2. Personal Use License. In addition to owning the NFT, Invenio Technologies, Inc. grants you a worldwide, non-exclusive, royalty-free license to use, copy, and display the complete artwork of any Genesis Pilot NFTs that you own. Show the world your Pilot!
3. Commercial Use License. In addition to the personal use license described above, Invenio Technologies, Inc. grants you a worldwide, non-exclusive license to use, copy, and display the complete artwork of any Genesis Pilot NFTs that you own, including creating derivative works based upon the artwork. Examples of such derivative works would be the use of the artwork on merchandise displaying copies of the artwork, such as t-shirts or a TV series. Also, congratulations on the TV series! Stated differently, if you can figure out a way to make money selling stuff with your Genesis Pilot on it then have at it. Note that if and when you ever decide to sell or transfer a Genesis Pilot NFT to a wallet that you do not own, the licenses granted under these terms are immediately extinguished, including those pertaining to any derivative works, and the new owner of the NFT becomes the license holder.

NO ASSURANCE OF VALUE INCREASE
Invenio Technologies, Inc. makes no assurances or guarantees regarding thefuture value or appreciation of the Genesis Pilots NFT collection. Buyers acknowledge that the purchase is primarily for aestheticand collectible purposes, not as an investment.

PROHIBITED USES
Although we want to be as generous as possible with your personal and commercial use license, we want to make sure NodeRunners assets are not used for any illegal, harmful, or immoral uses - human decency sort of stuff. Therefore, you are not permitted to use the artwork of any NodeRunners Genesis Pilot NFTs for any of the following: 
• In any way that violates any applicable federal, state, local or international law or regulation (including, without limitation, any laws regarding the export of data or software to and from the US or other countries). 
• To exploit, harm or attempt to exploit or harm minors in any way by exposing them to inappropriate content, asking for personally identifiable information or otherwise. 
• To generate content that supports or promotes prostitution.
• To promote or facilitate the prostitution of another person. 
• To knowingly assist, support, or facilitate advertising activities that violate any federal, state, local or international sex trafficking law. 
• To transmit, or procure the sending of, any advertising or promotional material, including any “junk mail”, “chain letter” or “spam” or any other similar solicitation. 
• To impersonate or attempt to impersonate an employee of Invenio Technologies, Inc., another user or any other person or entity. 
• To encourage or induce any third-party to engage in any of the activities prohibited above.

GENERAL TERMS
NodeRunners Genesis Pilots is a collection of non-fungible tokens (“NFTs”) on the Ethereum network and provide utility for the NodeRunners video game. Note that because the NodeRunners Genesis Pilot smart contract runs on the Ethereum network, there is no ability to undo, reverse, or restore any transactions. Owners of NodeRunners Genesis Pilots NFTs are therefore exclusively responsible for the safety and management of their own private Ethereum wallets and validating all transactions and contracts generated by this and any other website before approval. Basically, be super careful! This website is designed to allow for the minting of, and to provide general information about, NodeRunners Genesis Pilots NFTs. This website and its connected services are provided “as is” and “as available” without warranty of any kind. By using this website, you are accepting sole responsibility for any and all transactions involving NodeRunners Genesis Pilot NFTs. The Crypto, Metaverse, and NFT space is still the Wild West, and we all have to be extra safe and careful as there are a lot of scammers looking to take advantage of innocent people. And while we strive to make our community and owned properties as safe as humanly possible, we cannot control any actions of third parties outside of our space. Invenio Technologies does not own or control MetaMask, Rabby, Google Chrome, the Ethereum network, or any other third-party site, exchange, product, or service that you might access, visit, or use for the purpose of enabling you to buy, sell or trade any NodeRunners Genesis Pilot NFTs. Invenio Technologies, Inc. will ot be liable for the acts or omissions of any such third parties, nor will we be liable for any damage that you may suffer as a result of your transactions or any other interaction with any such third parties, including any direct, indirect, special, incidental, consequential or punitive damages, including but not limited to, personal injury, pain and suffering, emotional distress, loss of revenue, loss of profits, loss of business or anticipated savings, loss of use, loss of goodwill, loss of data, and whether caused by tort (including negligence), breach of contract or otherwise, even if foreseeable.`;

  return (
    <footer>
      <div className="flex items-center justify-around text-white mt-[100px]">
        <div className="mb-4 sm:ml-[-40px]">
          <img src={logo} alt="Condensed Logo" className="w-[200px] mt-10" />
        </div>
        <div className="flex items-center space-x-1 mt-10 xxs:mr-[20px]">
          <a
            href="https://twitter.com/noderunnersgg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={twitter}
              alt="Twitter Logo"
              className="h-12 w-12"
              onMouseEnter={handleMouseEnterTwitter}
              onMouseLeave={handleMouseLeaveTwitter}
            />
          </a>
          <a
            href="https://medium.com/@NodeRunnersgg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={medium}
              alt="Medium Logo"
              className="h-12 w-12"
              onMouseEnter={handleMouseEnterMedium}
              onMouseLeave={handleMouseLeaveMedium}
            />
          </a>
          <a
            href="https://discord.gg/noderunners"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={discord}
              alt="Discord Logo"
              className="h-12 w-12"
              onMouseEnter={handleMouseEnterDiscord}
              onMouseLeave={handleMouseLeaveDiscord}
            />
          </a>
          <a
            href="https://noderunners.gitbook.io/litepaper"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={gitbook}
              alt="Gitbook Logo"
              className="h-12 w-12"
              onMouseEnter={handleMouseEnterGitbook}
              onMouseLeave={handleMouseLeaveGitbook}
            />
          </a>
        </div>
      </div>
      <div className="mb-5">
        <p className="text-center xxs:text-[10px] xs:text-[11px] lg2:text-[14px] text-white ">
          <span
            className="terms-link"
            onClick={() => openModal("Terms & Conditions")}
          >
            Terms & Conditions
          </span>
        </p>
        <p className="text-center xxs:text-[10px] xs:text-[11px] lg2:text-[14px] text-white ">
          Copyright © 2024 NodeRunners. All Rights Reserved.
        </p>

        <Modal
          style={{ width: "100%", display: "flex" }}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          // modalContent={modalContent}
        >
          <div>
            <h2 className="text-lg font-bold">{modalContent}</h2>
            <div style={{ whiteSpace: "pre-wrap" }}>{termsText}</div>
          </div>
        </Modal>
      </div>
    </footer>
  );
};

export default Footer;
